// src/store/reducers/categoryReducer.js
import { CATEGORY_ACTIONS } from '../actions/actionTypes';

const initialState = {
  categories: [],
  selectedCategory: null,
  loading: false,
  error: null,
  success: null,
  meta: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 1,
  },
  filters: {
    page: 1,
    limit: 20,
    search: '',
    type: '',
    isActive: true,
    parentId: '',
    sortBy: 'order',
    sortOrder: 'asc',
  },
  categoryTree: [],
  stats: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch categories
    case CATEGORY_ACTIONS.FETCH_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload.data || [],
        meta: action.payload.meta || initialState.meta,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        categories: [],
      };

    // Fetch single category
    case CATEGORY_ACTIONS.FETCH_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCategory: action.payload || null,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        selectedCategory: null,
      };

    // Create category
    case CATEGORY_ACTIONS.CREATE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case CATEGORY_ACTIONS.CREATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [action.payload, ...state.categories],
        success: 'Catégorie créée avec succès',
        error: null,
      };

    case CATEGORY_ACTIONS.CREATE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Update category
    case CATEGORY_ACTIONS.UPDATE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case CATEGORY_ACTIONS.UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.map(cat =>
          cat.id === action.payload.id ? action.payload : cat
        ),
        selectedCategory: action.payload.data || state.selectedCategory,
        success: 'Catégorie mise à jour avec succès',
        error: null,
      };

    case CATEGORY_ACTIONS.UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Delete category
    case CATEGORY_ACTIONS.DELETE_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };

    case CATEGORY_ACTIONS.DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter(cat => cat.id !== action.payload.id),
        success: action.payload.message || 'Catégorie supprimée avec succès',
        error: null,
      };

    case CATEGORY_ACTIONS.DELETE_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
      };

    // Fetch category tree
    case CATEGORY_ACTIONS.FETCH_CATEGORY_TREE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORY_TREE_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryTree: action.payload,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORY_TREE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        categoryTree: [],
      };

    // Fetch category stats
    case CATEGORY_ACTIONS.FETCH_CATEGORY_STATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORY_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
        error: null,
      };

    case CATEGORY_ACTIONS.FETCH_CATEGORY_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        stats: null,
      };

    // Upload category image
    case CATEGORY_ACTIONS.UPLOAD_CATEGORY_IMAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.UPLOAD_CATEGORY_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCategory: {
          ...state.selectedCategory,
          image: action.payload,
          imageId: action.payload.id,
        },
        success: 'Image téléchargée avec succès',
        error: null,
      };

    case CATEGORY_ACTIONS.UPLOAD_CATEGORY_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Reorder categories
    case CATEGORY_ACTIONS.REORDER_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.REORDER_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload,
        success: 'Ordre mis à jour avec succès',
        error: null,
      };

    case CATEGORY_ACTIONS.REORDER_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Bulk delete
    case CATEGORY_ACTIONS.BULK_DELETE_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CATEGORY_ACTIONS.BULK_DELETE_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter(cat => !action.payload.ids.includes(cat.id)),
        success: action.payload.message || 'Catégories supprimées avec succès',
        error: null,
      };

    case CATEGORY_ACTIONS.BULK_DELETE_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Set filters
    case CATEGORY_ACTIONS.SET_CATEGORY_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    // Clear states
    case CATEGORY_ACTIONS.CLEAR_CATEGORY_ERROR:
      return {
        ...state,
        error: null,
      };

    case CATEGORY_ACTIONS.CLEAR_CATEGORY_SUCCESS:
      return {
        ...state,
        success: null,
      };

    case CATEGORY_ACTIONS.CLEAR_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: null,
        stats: null,
      };

    default:
      return state;
  }
};

export default categoryReducer;